export const EXPENSE_CATEGORIES = [
  { value: 'activities', label: 'Activities & Sports' },
  { value: 'medical', label: 'Medical & Dental' },
  { value: 'school', label: 'School & Education' },
  { value: 'clothing', label: 'Clothing' },
  { value: 'food', label: 'Food & Dining' },
  { value: 'childcare', label: 'Childcare' },
  { value: 'transportation', label: 'Transportation' },
  { value: 'entertainment', label: 'Entertainment' },
  { value: 'other', label: 'Other' }
];

export const DAYS_OF_WEEK = [
  'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
];

export const DAYS_OF_WEEK_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const SETTLEMENT_METHODS = [
  { value: 'venmo', label: 'Venmo' },
  { value: 'paypal', label: 'PayPal' },
  { value: 'zelle', label: 'Zelle' },
  { value: 'cash', label: 'Cash' },
  { value: 'other', label: 'Other' }
];

export const RECURRING_FREQUENCIES = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'biweekly', label: 'Every 2 Weeks' },
  { value: 'weekly', label: 'Weekly' }
];

export const EVENT_CATEGORIES = [
  { value: 'medical', label: 'Medical' },
  { value: 'school', label: 'School' },
  { value: 'social', label: 'Social' },
  { value: 'other', label: 'Other' }
];

export const GOOGLE_CALENDAR_SYNC_MODES = [
  { value: 'custody', label: 'Custody Schedule Only' },
  { value: 'activities', label: 'Activities & Events Only' },
  { value: 'both', label: 'Custody + Activities' }
];

export const DOCUMENT_CATEGORIES = [
  { value: 'medical', label: 'Medical Records' },
  { value: 'school', label: 'School Documents' },
  { value: 'legal', label: 'Legal Documents' },
  { value: 'id_insurance', label: 'ID & Insurance' },
  { value: 'other', label: 'Other' }
];

export const ALLOWED_FILE_TYPES = {
  'image/jpeg': '.jpg',
  'image/png': '.png',
  'image/heic': '.heic',
  'image/webp': '.webp',
  'application/pdf': '.pdf',
  'application/msword': '.doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
};

export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024; // 10MB

export const DEFAULT_CHILD_COLORS = [
  { hex: '#f59e0b', name: 'Amber' },
  { hex: '#10b981', name: 'Emerald' },
  { hex: '#8b5cf6', name: 'Purple' },
  { hex: '#ec4899', name: 'Pink' },
  { hex: '#06b6d4', name: 'Cyan' },
  { hex: '#ef4444', name: 'Red' },
  { hex: '#6366f1', name: 'Indigo' },
  { hex: '#84cc16', name: 'Lime' },
];
